export const envApi = {
  listDsEnv: '/rdp/console/api/v1/dsenv/list',
  addDsEnv: '/rdp/console/api/v1/dsenv/add',
  deleteEnv: '/rdp/console/api/v1/dsenv/delete',
  updateEnv: '/rdp/console/api/v1/dsenv/update'
};
